export default __webpack_public_path__ + "static/w1-cae7e96b230a386730761cd0b4a614eb.jpg";